module.exports = __webpack_public_path__ + "static/img/tab3Big.25be37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/tab3Big.png
// module id = I6kE
// module chunks = 1